// src/components/molecules/UserProfile/Edit/BioInput.js

import React from "react";

const BioInput = ({ bio, handleChange }) => {
  return (
    <textarea
      name="bio"
      value={bio}
      onChange={handleChange}
      rows="4"
      style={{
        width: "100%",
        backgroundColor: "#868A9C",
        color: "white",
        padding: "10px",
        border: "none",
        borderRadius: "4px",
        fontFamily: "basic-sans",
      }}
    />
  );
};

export default BioInput;
